"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalEvents = void 0;
var GlobalEvents;
(function (GlobalEvents) {
    GlobalEvents["SDK_INITIALISED"] = "sdkInitialized";
    GlobalEvents["SDK_DISPOSING"] = "sdkDisposing";
    GlobalEvents["SDK_DISPOSED"] = "sdkDisposed";
})(GlobalEvents = exports.GlobalEvents || (exports.GlobalEvents = {}));
//# sourceMappingURL=BringgDashboardSDK.consts.js.map